import { ComponentMeta, ComponentStory } from "@storybook/react";
import React from "react";
import { XCircleIcon, BanIcon, AlertCircleIcon } from "lucide-react";
import FeaturedIcon from "./FeaturedIcon";

type Story = ComponentStory<typeof FeaturedIcon>;

const commonArgs: React.ComponentProps<typeof FeaturedIcon> = {
    children: <XCircleIcon />
};

export default {
    title: "common/FeaturedIcon",
    component: FeaturedIcon,
    args: commonArgs
} as ComponentMeta<typeof FeaturedIcon>;

const Template: Story = args => <FeaturedIcon {...args} />;

export const Default = Template.bind({});

export const SmallPrimary = Template.bind({});
SmallPrimary.args = {
    size: "sm",
    color: "primary"
};

export const MediumWarning = Template.bind({});
MediumWarning.args = {
    size: "md",
    color: "warning",
    children: <BanIcon />
};

export const LargeError = Template.bind({});
LargeError.args = {
    size: "lg",
    color: "error",
    children: <AlertCircleIcon />
};

export const ExtraLarge = Template.bind({});
ExtraLarge.args = {
    size: "xl"
};

export const ExtraSmall = Template.bind({});
ExtraSmall.args = {
    size: "xs"
};
